<template>
  <div class="opage">
    <div>
      <!--  客户评价 -->
      <baseBreadcrumb :page="$t('message.customerEvaluation')" :menu="$t('message.operationAndMaintenance')" />
      <!-- 搜索 -->
      <div class="body">
        <!-- 状态筛选 -->
        <div class="tabs">
          <el-tabs v-model="datas.status" type="card" @tab-click="evaluationlist">
            <!-- 待确认 -->
            <!--2023/03/2 数字先不放,需要后端给接口 -->
            <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
            </el-tab-pane>
            <!-- 已确认 -->
            <el-tab-pane :label="$t('message.confirmed')" name="2">
            </el-tab-pane>
            <!-- 全部 -->
            <el-tab-pane :label="$t('message.all')" name="0">
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="search">
          <div class="row">
            <!--文本: 请输入客户ID -->
            <div class="item">
              <el-input v-model="datas.user_id" :placeholder="$t('message.pleaseEnterTheCustomerID')" clearable
                onfocus="this.select()">
              </el-input>
            </div>
            <!--文本: 请输入客户名称 -->
            <div class="item">
              <el-input v-model="datas.realname" :placeholder="$t('message.pleaseEnterTheCustomerName')" clearable
                onfocus="this.select()">
              </el-input>
            </div>
            <!--文本: 请输入配送单号 -->
            <div class="item">
              <el-input v-model="datas.porder_sn" :placeholder="$t('message.pleaseEnterTheTrackingNumber')" clearable
                onfocus="this.select()">
              </el-input>
            </div>
            <!-- 业务员 -->
            <div class="item">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 采购 -->
            <div class="item">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货 -->
            <div class="item">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <!-- <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button> -->
          </div>
        </div>
        <div class="table">
          <ol>
            <!-- 客户信息 -->
            <li>
              {{ $t("message.userInfo") }}
            </li>
            <!-- 对应人员 -->
            <li>
              {{ $t("message.correspondingPerson") }}
            </li>
            <!-- 配送单号 -->
            <li class="flex2">
              {{ $t("message.porderNumber") }}
            </li>
            <!-- 评价时间 -->
            <li>
              {{ $t("message.evaluationTime") }}
            </li>
            <!-- 客户评价 -->
            <li class="flex2">
              {{ $t("message.customerTestimonials") }}
            </li>
            <!-- 配送单整体评价 -->
            <li class="flex2">
              {{ $t('message.overallEvaluationOfDeliveryOrder') }}
            </li>
            <!-- 物流号 -->
            <li>
              {{ $t('message.logisticsNumber') }}
            </li>
            <!-- 处理备注 -->
            <li class="flex15">
              {{ $t("message.workWithNotes") }}
            </li>
            <!-- 操作 -->
            <li class="flex05">
              {{ $t("message.operation") }}
            </li>
            <!-- 确认截图 -->
            <li>
              {{ $t("message.confirmScreenshot") }}
            </li>
            <!-- 确认状态（时间） -->
            <li>
              {{ $t("message.confirmTheStatus") }}({{ $t("message.times") }})
            </li>
          </ol>
          <ul v-for="(tableItem, tableIndex) in tableData" :key="tableIndex">
            <!-- 客户信息 -->
            <li>
              <div class="listShow">
                <p>{{ tableItem.porder && tableItem.porder.user ? tableItem.porder.user.id : '' }}</p>
                <p>{{ tableItem.porder && tableItem.porder.user ? tableItem.porder.user.realname : '' }}</p>
                <p v-if="tableItem.porder">
                  <attributeName :name="tableItem.porder.user.attribute.name" />
                </p>
                <!-- RC和CW的聊天标识 -->
                <p v-if="tableItem.porder.user.chatwork"> <img src="@/assets/icon/chatword.png" alt=""
                    style="width: 40px; vertical-align: middle;">
                </p>
                <p v-else> <img src="@/assets/icon/Rakuchat.png" alt="" style="width: 40px; vertical-align: middle;">
                </p>
              </div>
            </li>
            <!-- 对应人员 -->
            <li>
              <div>
                <p>{{ tableItem.porder && tableItem.porder.y_admin ? tableItem.porder.y_admin.realname : ''
                }}</p>
                <p>{{ tableItem.porder && tableItem.porder.g_admin ? tableItem.porder.g_admin.realname : ''
                }}</p>
                <p>{{ tableItem.porder && tableItem.porder.p_admin ? tableItem.porder.p_admin.realname : ''
                }}</p>
              </div>
            </li>
            <!-- 配送单号 -->
            <li class="flex2">
              <router-link class="blurFont" :to="'/porderDetail?porder_sn=' + tableItem.porder_sn" target="_blank">{{
                tableItem.porder_sn
              }}</router-link>
            </li>
            <!-- 评价时间 -->
            <li>
              {{ tableItem.created_at }}
            </li>
            <!-- 客户评价 -->
            <li class="flex2">
              <div class="overallProductSatisfactionBox">
                <!-- 商品整体满意度 -->
                <p>
                  <span>{{ $t('message.overallProductSatisfaction') }}</span>
                  <el-rate disabled v-model="tableItem.goods_whole_score"></el-rate>
                </p>
                <!-- 服务整体满意度 -->
                <p>
                  <span>{{ $t('message.overallServiceSatisfaction') }}</span>
                  <el-rate disabled v-model="tableItem.service_whole_score"></el-rate>
                </p>
                <!-- 物流满意度 -->
                <p>
                  <span>{{ $t('message.logisticsSatisfaction') }}</span>
                  <el-rate disabled v-model="tableItem.logistics_whole_score"></el-rate>
                </p>
                <p>
                  <!-- 查看明细 -->
                  <el-button type="success" size="mini" @click="seeDetails(tableItem)">
                    {{ $t('message.viewDetails') }}
                  </el-button>
                </p>
              </div>
            </li>
            <!-- 配送单整体评价 -->
            <li class="flex2">
              <div class="template ">
                <div class="porder_desc">
                  <el-popover placement="top-start" width="200" trigger="hover" :content="tableItem.porder_desc">
                    <span slot="reference"> {{ tableItem.porder_desc }}</span>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 物流号 -->
            <li>
              <div>
                <p v-for="express in tableItem.logisticsList" @click="logisticsTrack(express.express_no)">
                  <el-popover placement="left" title="国际物流:" width="400" trigger="click">
                    <div v-if="activities != false" style="max-height: 600px; overflow-y: auto;">
                      <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities" :key="index"
                          :timestamp="activity.time" :color="activity.color" placement="top">
                          {{ activity.address }}
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                    <p v-else> 暂无物流信息 </p>
                    <p slot="reference">
                      <span class="WL">
                        <a href="javascript:;" class="a-link"> {{ express.express_no }}</a>
                      </span>
                    </p>
                  </el-popover>
                </p>
              </div>
            </li>
            <!-- 图片 -->
            <!-- <li class="imageLI">
              <div v-for="(imageItem, imageIndex) in tableItem.images" :key="imageIndex">
                <el-popover placement='right' trigger='hover'>
                  <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                  <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                </el-popover>
              </div>
            </li> -->
            <!-- 处理备注 -->
            <li class="flex15">
              <el-input :disabled="!!tableItem.confirm_at" @change="evaluationupdateDealRemark(tableItem)"
                type="textarea" v-model="tableItem.deal_remark" v-if="isAuth(432)" resize="none"></el-input>
              <span v-else>{{ tableItem.deal_remark }}</span>
            </li>
            <!-- 操作 -->
            <li class="flex05">
              <!-- 确认 -->
              <el-button v-if="!tableItem.confirm_at && isAuth(433)" type='success' class="secondary"
                @click="notarize(tableItem)" size="small">{{
                  $t('message.notarize') }}</el-button>
            </li>
            <!-- 确认图片 -->
            <li>
              <el-image style="width: 60px; height: 60px" :src="img" :preview-src-list="[img]"
                v-for="(img, imgs) in tableItem.confirm_images" :key="imgs">
              </el-image>
            </li>
            <!-- 确认状态（时间） -->
            <li>
              <!-- 文本: 待确认 -->
              {{ tableItem.confirm_at ? tableItem.confirm_at : $t('message.toBeConfirmed') }}
            </li>
          </ul>
          <div v-if="tableData == false" class="No_data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 客户评价查看详情 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="detailshow">
      <div class="scoreInDetail">
        <!-- 配送单号 -->
        <h1>
          <span>
            <span>{{ $t('message.porderNumber') }}:</span>
            <span>{{ detailshowData.porder_sn }}</span>
          </span>
          <!-- 查看配送单 -->
          <router-link :to="'/porderDetail?porder_sn=' + detailshowData.porder_sn" target="_blank">
            <el-button type='primary' size="mini">{{
              $t('message.viewTheDeliveryNote') }}</el-button>
          </router-link>
        </h1>
        <!-- 满意度为1到5星，星级越高越满意 -->
        <h2>{{ $t('message.satisfactionIs1To5Stars') }}</h2>
        <ul>
          <!-- 商品整体满意度 -->
          <li>
            <div class="row1">
              <!-- 文本: 商品整体满意度 -->
              <label>
                {{ $t('message.overallProductSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_whole_score"></el-rate>
            </div>
          </li>
          <!-- 商品包装是否满意 -->
          <li>
            <div class="row1">
              <!--文本: 商品包装是否满意 -->
              <label>
                {{ $t('message.whetherTheProductPackagingIsSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_pack_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.goods_pack_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_pack_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 商品质量是否符合您的预期 -->
          <li>
            <div class="row1">
              <!--文本: 商品质量是否符合您的预期 -->
              <label>
                {{ $t('message.whetherTheQualityOfTheProductMeetsYourExpectations') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_quality_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.goods_quality_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_quality_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 商品是否完整（有无缺失，破损） -->
          <li>
            <div class="row1">
              <!--文本: 商品是否完整（有无缺失，破损） -->
              <label>
                {{ $t('message.whetherTheProductIsComplete') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_complete_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.goods_complete_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_complete_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务整体满意度： -->
          <li>
            <div class="row1">
              <!--文本: 服务整体满意度： -->
              <label>
                {{ $t('message.overallServiceSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_whole_score"></el-rate>
            </div>
          </li>
          <!-- 服务流程是否满意 -->
          <li>
            <div class="row1">
              <!--文本:服务流程是否满意 -->
              <label>
                {{ $t('message.whetherTheServiceProcessIsSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_process_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.service_process_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_process_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否能精准到位满足您的需求 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否能精准到位满足您的需求 -->
              <label>
                {{ $t('message.whetherTheServiceStaffIsInPlaceToMeetYourNeeds') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.service_admin_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否态度良好 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否态度良好 -->
              <label>
                {{ $t('message.whetherTheServiceStaffHasAGoodAttitude') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_attitude_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.service_admin_attitude_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_attitude_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否处理问题及时 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否处理问题及时 -->
              <label>
                {{ $t('message.whetherTheServiceStaffHandledTheProblemInATimelyManner') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_speed_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.service_admin_speed_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_speed_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流满意度 -->
          <li>
            <div class="row1">
              <!--文本:物流满意度 -->
              <label>
                {{ $t('message.logisticsSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_whole_score"></el-rate>
            </div>
          </li>
          <!-- 对此物流速度是否满意 -->
          <li>
            <div class="row1">
              <!--文本:对此物流速度是否满意 -->
              <label>
                {{ $t('message.whetherYouAreSatisfiedWithTheSpeedOfThisLogistics') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_speed_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.logistics_speed_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_speed_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流费用是否满意 -->
          <li>
            <div class="row1">
              <!--文本:物流费用是否满意 -->
              <label>
                {{ $t('message.whetherTheLogisticsCostsAreSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_fee_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.logistics_fee_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_fee_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流服务（通关，配送等）是否满意 -->
          <li>
            <div class="row1">
              <!--文本:物流服务（通关，配送等）是否满意 -->
              <label>
                {{ $t('message.whetherTheLogisticsService') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_pass_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.logistics_pass_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_pass_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 配送单整体评价： -->
          <li>
            <div class="row1">
              <!--文本:配送单整体评价： -->
              <label>
                {{ $t('message.overallEvaluationOfTheDeliveryOrder') }}:
              </label>
            </div>
            <div class="row2">
              <el-input type="textarea" disabled v-model="detailshowData.porder_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.porder_images" :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 客户评价-确认 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" center title="客户评价-确认" width="500px">
      <div class="imgList">
        <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
          :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleAvatarSuccess"
          :file-list="imgList">
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="evaluationconfirm">{{
          $t('message.notarize') }}</el-button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusRange: "[]", //statusRange规则由split改成stringify,所以设置 "[]"为初始值
      total: 0,
      num: 0,
      datas: {
        status: '1'
      },
      tableData: [],
      detailshow: false,//查看详情弹窗开关
      dialogVisible: false,//查看详情弹窗开关
      confirmData: {
        confirm_images: [],
        id: ''
      },//确认数据
      imgList: [],
      detailshowData: {},//查看详情弹窗数据
      dialogImageUrl: '',
      picDialogVisible: false,
      activities: []
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  component: {},
  created() {
    this.evaluationlist();
  },
  methods: {
    notarize(item) {
      this.confirmData = {
        id: item.id,
        confirm_images: []
      }
      this.imgList = []
      this.dialogVisible = true
    },
    // 确认客户评价
    evaluationconfirm() {
      this.imgList.forEach(item => {
        this.confirmData.confirm_images.push(item.response.data)
      })
      // 是否确认当前评价
      this.$confirm(this.$t('message.whetherToConfirmTheCurrentRating'), this.$t('message.hint'), {
        confirmButtonText: this.$t('message.ok'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.siteConfiguration
          .evaluationconfirm(this.confirmData).then(res => {
            ////console.log('事件名',res)
            if (res.code != 0) return this.$message.error(res.data.msg)
            this.dialogVisible = false
            this.imgList = []
            //接下来的操作
            this.evaluationlist()
          })
      })
    },
    // 点击图片打开图片页
    toImgePage(href) {
      window.open(href, '_blank');
    },
    // 查看详情
    seeDetails(data) {
      this.detailshow = true;
      this.detailshowData = data
    },
    // 获取表格数据
    evaluationlist() {
      this.$api.siteConfiguration
        .evaluationlist().then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg)
          //接下来的操作
          this.evaluationlist()
        })
    },
    // 保存备注
    evaluationupdateDealRemark(item) {
      this.$api.siteConfiguration
        .evaluationupdateDealRemark({
          id: item.id,
          deal_remark: item.deal_remark
        }).then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg)
          //接下来的操作
          // this.evaluationlist()
        })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
      };
      this.evaluationlist();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.evaluationlist();
    },
    // 获取配送单列表
    evaluationlist() {
      this.$api.siteConfiguration.evaluationlist(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        res.data.data.forEach(element => {
          if (element.porder_images != false) {
            element.porder_images = JSON.parse(element.porder_images)
          }
        });
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.evaluationlist();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.evaluationlist();
    },
    handleRemove(file, fileList) {
      this.imgList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.picDialogVisible = true;
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(fileList);
      this.imgList = fileList
    },
    // 跳转物流
    logisticsTrack(express_no) {
      let datas = {
        express_no
      }
      this.$api.logisticsTrack(datas).then(res => {
        if (res.data.address_data != false) {
          res.data.address_data[0].color = '#B4272D'
        }
        this.activities = res.data.address_data
      })
    },

  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.template {
  height: 100%;
  display: flex;
  overflow-y: auto;

  .porder_desc {
    flex: 2;
  }

  .imgs {
    flex: 1;
  }
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 12px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .imageLI {
    flex-wrap: wrap;
    flex: 0 0 100px;

    img {
      width: 36px;
      height: 36px;
      margin: 0 6px 6px 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;


  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    min-height: 100px;

    /deep/.el-textarea__inner {
      min-height: 100px !important;
      padding: 3px;
    }

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.listShow {
  text-align: center;
}

.overallProductSatisfactionBox {
  p {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 5px;

    span {
      margin-right: 10px;
      min-width: 40%;
    }

    .el-button {
      margin-left: auto;
    }
  }
}

.scoreInDetail {
  h1 {
    span {
      font-size: 20px;
      font-weight: bold;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:40px;
  }

  h2 {
    color: red;
    margin-bottom: 15px;
  }

  ul {
    max-height: 600px;
    overflow-y: auto;

    li {
      margin-bottom: 30px;

      .row1 {
        display: flex;
        margin-bottom: 15px;
      }

      .row2 {
        display: flex;
        align-items: flex-start;

        .el-textarea {
          width: 40%;
          margin-right: 20px;

          /deep/.el-textarea__inner {
            height: 80px;
          }


        }

        .imgBox {
          display: flex;
          flex-wrap: wrap;

          .imgs {
            margin: 0 10px 10px 0;
          }
        }
      }
    }
  }
}

.backImg {
  width: 80px;
  height: 80px;
}
</style>